import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import UpdateQuestionPopup from "./updateQuestionPopup";
import { deleteQuestion } from "@/api/deleteCandidateQuestion";
import { useToast } from "../toast";
import EditQuestionPopup from "./editQuestionPopup";
import SendAssessmentLink from "./SendAssessmentLink";
import { IoClose } from "react-icons/io5";
import api from "@/components/customAxios/Axios";
import { useLoader } from "@/context/loaderContext";

export interface UpdateQuestionData {
	resume_id: string;
	job_id: string;
	question_id: string;
	question_type: "behavioral" | "technical" | "coding";
}

export interface EditQuestionData {
	resume_id: string;
	job_id: string;
	question_id: string;
	question_type: "behavioural" | "technical" | "coding";
	question: string;
	sample_input?: string;
	sample_output?: string;
	options?: { [key: string]: string };
	answer?: string;
}

type behavioralQuestionsType = {
	b_question_id: string;
	b_question_text: string;
}[];
type technicalQuestionsType = {
	tech_ques_id: string;
	question: string;
	options: { [key: string]: string };
	answer: string;
}[];
type codingQuestionType = {
	coding_ques_id: string;
	question: string;
	sample_input: string;
	sample_output: string;
}[];

export default function GeneratedQuesPopup({
	resume_id,
	onClose,
	jobId,
}: {
	resume_id: string;
	onClose: () => void;
	jobId: number | null;
}) {
	const toast = useToast();
	const { setLoading } = useLoader();
	const [updateStatus, setUpdateStatus] = useState(false);
	const [editStatus, setEditStatus] = useState(false);
	const [data, setData] = useState<UpdateQuestionData | undefined>();
	const [editData, setEditData] = useState<EditQuestionData | undefined>();
	const [validityDays, setvalidityDays] = useState("");
	const [candidateId, setCandidateId] = useState("");
	const [behavioralQuestions, setBehavioralQuestions] =
		useState<behavioralQuestionsType>([]);
	const [technicalQuestions, setTechnicalQuestions] =
		useState<technicalQuestionsType>([]);
	const [codingQuestions, setCodingQuestion] = useState<codingQuestionType>([]);
	const [getNewQuestions, setGetNewQuestions] = useState(false);

	const getQuestions = async () => {
		try {
			setLoading(true);
			const response = await api.post(
				"/fetch_candidate_questions_after_selected",
				{
					resume_id: resume_id,
					job_id: jobId,
				}
			);
			if (response.data) {
				setBehavioralQuestions(response.data.Behaviour_q);
				setTechnicalQuestions(response.data.tech_questions);
				setCodingQuestion(response.data.coding_question);
				setCandidateId(response.data.candidate_id);
				setvalidityDays(response.data.validity_days);
			}
		} catch (error: any) {
			toast.error({
				duration: 5000,
				status: "error",
				title: "Error Fetching Questions",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to fetch candidate questions. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getQuestions();
	}, [getNewQuestions]);

	return (
		<div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-10">
			<div className="relative bg-white dark:bg-zinc-700 rounded-lg shadow p-6 w-full max-w-5xl overflow-auto max-h-[calc(100vh-1rem)]">
				{updateStatus && data && (
					<UpdateQuestionPopup
						onClose={() => setUpdateStatus(false)}
						data={data}
						setGetNewQuestions={setGetNewQuestions}
					/>
				)}
				{editStatus && editData && (
					<EditQuestionPopup
						onClose={() => setEditStatus(false)}
						data={editData}
						setGetNewQuestions={setGetNewQuestions}
					/>
				)}
				<button
					onClick={onClose}
					className="absolute top-2 md:right-3 right-8 p-2 rounded-full bg-red-500 text-white font-medium  shadow-md hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-red-300 transition-transform transform hover:scale-105"
					aria-label="Close Modal"
				>
					<IoClose size={20} />
				</button>
				{behavioralQuestions && (
					<div className="space-y-8">
						{/* Behavioral Questions Section */}

						<section>
							<div className="flex justify-between items-center mb-4">
								<h2 className="text-lg text-gray-500 font-semibold font-subheading">
									Behavioral Questions
								</h2>
								{/* <AddNewBehaviouralQuestion getQuestions={getQuestions} /> */}
							</div>
							<div className="space-y-4 font-body">
								{behavioralQuestions.map((elem, index) => (
									<div
										className=" p-2 border-1 rounded-lg grid grid-cols-[90%_10%]"
										key={elem.b_question_id}
									>
										<div className="flex  px-2 py-1">
											<span className="text-lg font-medium">{index + 1}.</span>
											<p className="ml-0 md:ml-2 text-lg">
												{elem.b_question_text}
											</p>
										</div>
										<div className="flex justify-end mt-2 gap-3">
											<button
												onClick={() => {
													setData({
														resume_id: resume_id,
														job_id: localStorage.getItem("job_id") || "",
														question_id: elem.b_question_id,
														question_type: "behavioral",
													});
													setUpdateStatus(true);
												}}
												className=""
											>
												<svg
													width="17"
													height="17"
													viewBox="0 0 17 17"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M14.0494 2.86795C11.3273 0.185866 7.14037 -0.114786 4.08712 1.93976L4.07857 0.760291C4.07713 0.561773 3.91498 0.401995 3.71639 0.403576L2.99771 0.409182C2.79926 0.410691 2.6397 0.57277 2.64114 0.771145L2.66098 3.46107C2.66378 3.85623 2.98528 4.17421 3.37973 4.17421C3.38116 4.17421 3.38325 4.17421 3.38533 4.17421L6.07561 4.15437C6.27413 4.15294 6.43384 3.99071 6.43233 3.79219L6.42672 3.07337C6.42521 2.87493 6.26314 2.71536 6.06476 2.7168L5.60749 2.72011C8.01372 1.51893 11.02 1.90138 13.0401 3.89131C14.9787 5.80232 15.5084 8.67517 14.4068 11.1385C14.3284 11.3139 14.3926 11.5183 14.5637 11.6057L15.2052 11.9335C15.3869 12.0263 15.6168 11.9515 15.7012 11.7657C17.0716 8.74675 16.4293 5.21403 14.0494 2.86795ZM13.6205 12.8259C13.619 12.8259 13.617 12.8259 13.6149 12.8259L10.9246 12.8456C10.7261 12.8472 10.5664 13.0093 10.5679 13.2078L10.5735 13.9266C10.575 14.125 10.7371 14.2846 10.9354 14.2832L11.3923 14.2799C8.9859 15.4808 5.98009 15.098 3.96012 13.1087C2.0215 11.1977 1.49179 8.32478 2.59341 5.86148C2.67183 5.6861 2.60757 5.48176 2.43651 5.39429L1.79503 5.06654C1.61325 4.97368 1.3834 5.0485 1.29902 5.23429C-0.071495 8.25319 0.570852 11.7859 2.95071 14.1321C4.48854 15.6475 6.49465 16.4027 8.49924 16.4027C10.0428 16.4027 11.5848 15.9534 12.9129 15.0594L12.9214 16.2396C12.9229 16.4382 13.085 16.5979 13.2836 16.5964L14.0023 16.5908C14.2007 16.5892 14.3603 16.4272 14.3588 16.2288L14.339 13.5389C14.3364 13.1438 14.015 12.8259 13.6205 12.8259Z"
														fill="black"
													/>
												</svg>
											</button>
											<button
												onClick={() => {
													deleteQuestion({
														resume_id: resume_id,
														jobId: localStorage.getItem("job_id") || "",
														question_id: elem.b_question_id,
														question_type: "behavioral",
														toast: toast,
														setGetNewQuestions,
													});
												}}
												className=""
											>
												<svg
													width="17"
													height="18"
													viewBox="0 0 17 18"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M2.58398 5.25V15.6667C2.58398 15.9982 2.71568 16.3161 2.9501 16.5505C3.18452 16.785 3.50246 16.9167 3.83398 16.9167H13.0006C13.3322 16.9167 13.6501 16.785 13.8845 16.5505C14.119 16.3161 14.2506 15.9982 14.2506 15.6667V5.25H2.58398Z"
														stroke="black"
													/>
													<path
														d="M5.08398 7.67501V14.4917M8.41732 7.67501V14.4917M11.7507 7.67501V14.4917M5.50065 2.61084V1.70334C5.50065 1.13084 6.02315 0.666672 6.66732 0.666672H10.1673C10.8115 0.666672 11.334 1.13084 11.334 1.70334V2.61167"
														stroke="black"
														strokeLinecap="round"
													/>
													<path
														d="M14.667 2.75H2.16699C1.47664 2.75 0.916992 3.30964 0.916992 4C0.916992 4.69036 1.47664 5.25 2.16699 5.25H14.667C15.3573 5.25 15.917 4.69036 15.917 4C15.917 3.30964 15.3573 2.75 14.667 2.75Z"
														stroke="black"
													/>
												</svg>
											</button>
											<button
												onClick={() => {
													setEditData({
														resume_id: resume_id,
														job_id: localStorage.getItem("job_id") || "",
														question_id: elem.b_question_id,
														question_type: "behavioural",
														question: elem.b_question_text,
													});
													setEditStatus(true);
												}}
												className=""
											>
												<svg
													width="17"
													height="17"
													viewBox="0 0 17 17"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M15.7185 15.0356H1.28091C0.98487 15.0356 0.734375 15.2861 0.734375 15.5822C0.734375 15.8782 0.98487 16.1287 1.28091 16.1287H15.7185C16.0146 16.1287 16.2651 15.8782 16.2651 15.5822C16.2651 15.2861 16.0146 15.0356 15.7185 15.0356ZM0.757147 10.2535L0.734375 12.8267C0.734375 12.9634 0.77992 13.1228 0.893781 13.2139C1.00764 13.305 1.14428 13.3733 1.28091 13.3733L3.85418 13.3505C3.99081 13.3505 4.12744 13.2822 4.24131 13.1911L13.0769 4.35545C13.2819 4.1505 13.2819 3.78614 13.0769 3.58119L10.5265 1.0307C10.3215 0.825746 9.95715 0.825746 9.7522 1.0307L7.97596 2.80693L0.916553 9.86634C0.802692 9.9802 0.757147 10.1168 0.757147 10.2535ZM11.9156 3.96832L10.9136 4.9703L9.13735 3.19406L10.1393 2.19208L11.9156 3.96832ZM1.85022 10.4812L8.36309 3.96832L10.1393 5.74456L3.62645 12.2574H1.85022V10.4812Z"
														fill="black"
													/>
												</svg>
											</button>

											{/* <RegenerateQuestionModal
														questionId={index}
														questionType="behavioral"
														getQuestions={getQuestions}
													/>

													<UpdateBehaviouralQuestionModal
														curentQuestionIndex={index}
														question={elem.b_question_text}
														behaviouralQuestionSet={data.Behaviour_q}
														getQuestions={getQuestions}
													/>

													<DeleteQuestionModal
														getQuestions={getQuestions}
														currentQuestionIndex={index}
														behaviouralQuestionSet={data.Behaviour_q}
														section="behavioral"
													/> */}
										</div>
									</div>
								))}
							</div>
						</section>
						{/* Technical Questions Section */}
						<section>
							<div className="flex justify-between items-center mb-4">
								<h2 className="text-lg text-gray-500 font-semibold font-subheading">
									Technical Questions
								</h2>
								{/* <AddNewTechnicalQuestion getQuestions={getQuestions} /> */}
							</div>
							<div className="space-y-6 font-body">
								{technicalQuestions.map((elem, index) => (
									<div
										className=" p-2 border-1 rounded-lg grid grid-cols-[90%_10%]"
										key={index}
									>
										<div>
											<div className=" flex  px-2 py-1">
												<span className="text-lg font-medium">
													{index + 1}.
												</span>
												<p className="ml-2">{elem.question}</p>
											</div>

											<div className="pl-4 ">
												<p className="font-semibold mt-3 mb-1.5">Options:</p>
												<ul className="list-disc pl-6 space-y-2">
													<li>A. {elem.options.A}</li>
													<li>B. {elem.options.B}</li>
													<li>C. {elem.options.C}</li>
													<li>D. {elem.options.D}</li>
												</ul>
											</div>
											<div className="pl-4">
												<p className="font-semibold my-2">Answer:</p>
												<p className="px-3 rounded mb-2">{elem.answer}</p>
											</div>
										</div>
										<div className=" space-x-3">
											<button
												onClick={() => {
													setData({
														resume_id: resume_id,
														job_id: localStorage.getItem("job_id") || "",
														question_id: elem.tech_ques_id,
														question_type: "technical",
													});
													setUpdateStatus(true);
												}}
												className=""
											>
												<svg
													width="17"
													height="17"
													viewBox="0 0 17 17"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M14.0494 2.86795C11.3273 0.185866 7.14037 -0.114786 4.08712 1.93976L4.07857 0.760291C4.07713 0.561773 3.91498 0.401995 3.71639 0.403576L2.99771 0.409182C2.79926 0.410691 2.6397 0.57277 2.64114 0.771145L2.66098 3.46107C2.66378 3.85623 2.98528 4.17421 3.37973 4.17421C3.38116 4.17421 3.38325 4.17421 3.38533 4.17421L6.07561 4.15437C6.27413 4.15294 6.43384 3.99071 6.43233 3.79219L6.42672 3.07337C6.42521 2.87493 6.26314 2.71536 6.06476 2.7168L5.60749 2.72011C8.01372 1.51893 11.02 1.90138 13.0401 3.89131C14.9787 5.80232 15.5084 8.67517 14.4068 11.1385C14.3284 11.3139 14.3926 11.5183 14.5637 11.6057L15.2052 11.9335C15.3869 12.0263 15.6168 11.9515 15.7012 11.7657C17.0716 8.74675 16.4293 5.21403 14.0494 2.86795ZM13.6205 12.8259C13.619 12.8259 13.617 12.8259 13.6149 12.8259L10.9246 12.8456C10.7261 12.8472 10.5664 13.0093 10.5679 13.2078L10.5735 13.9266C10.575 14.125 10.7371 14.2846 10.9354 14.2832L11.3923 14.2799C8.9859 15.4808 5.98009 15.098 3.96012 13.1087C2.0215 11.1977 1.49179 8.32478 2.59341 5.86148C2.67183 5.6861 2.60757 5.48176 2.43651 5.39429L1.79503 5.06654C1.61325 4.97368 1.3834 5.0485 1.29902 5.23429C-0.071495 8.25319 0.570852 11.7859 2.95071 14.1321C4.48854 15.6475 6.49465 16.4027 8.49924 16.4027C10.0428 16.4027 11.5848 15.9534 12.9129 15.0594L12.9214 16.2396C12.9229 16.4382 13.085 16.5979 13.2836 16.5964L14.0023 16.5908C14.2007 16.5892 14.3603 16.4272 14.3588 16.2288L14.339 13.5389C14.3364 13.1438 14.015 12.8259 13.6205 12.8259Z"
														fill="black"
													/>
												</svg>
											</button>
											<button
												onClick={() =>
													deleteQuestion({
														resume_id: resume_id,
														jobId: localStorage.getItem("job_id") || "",
														question_id: elem.tech_ques_id,
														question_type: "technical",
														toast: toast,
														setGetNewQuestions,
													})
												}
												className=""
											>
												<svg
													width="17"
													height="18"
													viewBox="0 0 17 18"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M2.58398 5.25V15.6667C2.58398 15.9982 2.71568 16.3161 2.9501 16.5505C3.18452 16.785 3.50246 16.9167 3.83398 16.9167H13.0006C13.3322 16.9167 13.6501 16.785 13.8845 16.5505C14.119 16.3161 14.2506 15.9982 14.2506 15.6667V5.25H2.58398Z"
														stroke="black"
													/>
													<path
														d="M5.08398 7.67501V14.4917M8.41732 7.67501V14.4917M11.7507 7.67501V14.4917M5.50065 2.61084V1.70334C5.50065 1.13084 6.02315 0.666672 6.66732 0.666672H10.1673C10.8115 0.666672 11.334 1.13084 11.334 1.70334V2.61167"
														stroke="black"
														strokeLinecap="round"
													/>
													<path
														d="M14.667 2.75H2.16699C1.47664 2.75 0.916992 3.30964 0.916992 4C0.916992 4.69036 1.47664 5.25 2.16699 5.25H14.667C15.3573 5.25 15.917 4.69036 15.917 4C15.917 3.30964 15.3573 2.75 14.667 2.75Z"
														stroke="black"
													/>
												</svg>
											</button>
											<button
												onClick={() => {
													setEditData({
														resume_id: resume_id,
														job_id: localStorage.getItem("job_id") || "",
														question_id: elem.tech_ques_id,
														question_type: "technical",
														question: elem.question,
														options: elem.options,
														answer: elem.answer,
													});
													setEditStatus(true);
												}}
												className=""
											>
												<svg
													width="17"
													height="17"
													viewBox="0 0 17 17"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M15.7185 15.0356H1.28091C0.98487 15.0356 0.734375 15.2861 0.734375 15.5822C0.734375 15.8782 0.98487 16.1287 1.28091 16.1287H15.7185C16.0146 16.1287 16.2651 15.8782 16.2651 15.5822C16.2651 15.2861 16.0146 15.0356 15.7185 15.0356ZM0.757147 10.2535L0.734375 12.8267C0.734375 12.9634 0.77992 13.1228 0.893781 13.2139C1.00764 13.305 1.14428 13.3733 1.28091 13.3733L3.85418 13.3505C3.99081 13.3505 4.12744 13.2822 4.24131 13.1911L13.0769 4.35545C13.2819 4.1505 13.2819 3.78614 13.0769 3.58119L10.5265 1.0307C10.3215 0.825746 9.95715 0.825746 9.7522 1.0307L7.97596 2.80693L0.916553 9.86634C0.802692 9.9802 0.757147 10.1168 0.757147 10.2535ZM11.9156 3.96832L10.9136 4.9703L9.13735 3.19406L10.1393 2.19208L11.9156 3.96832ZM1.85022 10.4812L8.36309 3.96832L10.1393 5.74456L3.62645 12.2574H1.85022V10.4812Z"
														fill="black"
													/>
												</svg>
											</button>
										</div>
									</div>
								))}
							</div>
						</section>
						{/* Coding Questions Section */}
						{codingQuestions && (
							<>
								<section>
									<div className="flex justify-between items-center mb-4">
										<h2 className="text-lg text-gray-500 font-semibold font-subheading">
											Coding Questions
										</h2>
										{/* <AddNewCodingQuestion getQuestions={getQuestions} /> */}
									</div>
									<div className="space-y-6 font-body">
										{codingQuestions.map((elem, index) => (
											<div
												className=" p-2 border-1 rounded-lg grid grid-cols-[90%_10%]"
												key={index}
											>
												<div>
													<div className=" flex  px-2 py-1">
														<span className="text-lg font-medium">
															{index + 1}.
														</span>
														<p className="ml-2">{elem.question}</p>
													</div>
													<div className="pl-4 space-y-1 mt-2">
														<p className="font-semibold">Sample Input:</p>
														<p className="p-2">{elem.sample_input}</p>
														<p className="font-semibold mt-2">Sample Output:</p>
														<p className="p-2">{elem.sample_output}</p>
													</div>
												</div>
												<div className="space-x-3">
													<button
														onClick={() => {
															setData({
																resume_id: resume_id,
																job_id: localStorage.getItem("job_id") || "",
																question_id: elem.coding_ques_id,
																question_type: "coding",
															});
															setUpdateStatus(true);
														}}
														className=""
													>
														<svg
															width="17"
															height="17"
															viewBox="0 0 17 17"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M14.0494 2.86795C11.3273 0.185866 7.14037 -0.114786 4.08712 1.93976L4.07857 0.760291C4.07713 0.561773 3.91498 0.401995 3.71639 0.403576L2.99771 0.409182C2.79926 0.410691 2.6397 0.57277 2.64114 0.771145L2.66098 3.46107C2.66378 3.85623 2.98528 4.17421 3.37973 4.17421C3.38116 4.17421 3.38325 4.17421 3.38533 4.17421L6.07561 4.15437C6.27413 4.15294 6.43384 3.99071 6.43233 3.79219L6.42672 3.07337C6.42521 2.87493 6.26314 2.71536 6.06476 2.7168L5.60749 2.72011C8.01372 1.51893 11.02 1.90138 13.0401 3.89131C14.9787 5.80232 15.5084 8.67517 14.4068 11.1385C14.3284 11.3139 14.3926 11.5183 14.5637 11.6057L15.2052 11.9335C15.3869 12.0263 15.6168 11.9515 15.7012 11.7657C17.0716 8.74675 16.4293 5.21403 14.0494 2.86795ZM13.6205 12.8259C13.619 12.8259 13.617 12.8259 13.6149 12.8259L10.9246 12.8456C10.7261 12.8472 10.5664 13.0093 10.5679 13.2078L10.5735 13.9266C10.575 14.125 10.7371 14.2846 10.9354 14.2832L11.3923 14.2799C8.9859 15.4808 5.98009 15.098 3.96012 13.1087C2.0215 11.1977 1.49179 8.32478 2.59341 5.86148C2.67183 5.6861 2.60757 5.48176 2.43651 5.39429L1.79503 5.06654C1.61325 4.97368 1.3834 5.0485 1.29902 5.23429C-0.071495 8.25319 0.570852 11.7859 2.95071 14.1321C4.48854 15.6475 6.49465 16.4027 8.49924 16.4027C10.0428 16.4027 11.5848 15.9534 12.9129 15.0594L12.9214 16.2396C12.9229 16.4382 13.085 16.5979 13.2836 16.5964L14.0023 16.5908C14.2007 16.5892 14.3603 16.4272 14.3588 16.2288L14.339 13.5389C14.3364 13.1438 14.015 12.8259 13.6205 12.8259Z"
																fill="black"
															/>
														</svg>
													</button>
													<button
														onClick={() =>
															deleteQuestion({
																resume_id: resume_id,
																jobId: localStorage.getItem("job_id") || "",
																question_id: elem.coding_ques_id,
																question_type: "coding",
																toast: toast,
																setGetNewQuestions,
															})
														}
														className=""
													>
														<svg
															width="17"
															height="18"
															viewBox="0 0 17 18"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																fillRule="evenodd"
																clipRule="evenodd"
																d="M2.58398 5.25V15.6667C2.58398 15.9982 2.71568 16.3161 2.9501 16.5505C3.18452 16.785 3.50246 16.9167 3.83398 16.9167H13.0006C13.3322 16.9167 13.6501 16.785 13.8845 16.5505C14.119 16.3161 14.2506 15.9982 14.2506 15.6667V5.25H2.58398Z"
																stroke="black"
															/>
															<path
																d="M5.08398 7.67501V14.4917M8.41732 7.67501V14.4917M11.7507 7.67501V14.4917M5.50065 2.61084V1.70334C5.50065 1.13084 6.02315 0.666672 6.66732 0.666672H10.1673C10.8115 0.666672 11.334 1.13084 11.334 1.70334V2.61167"
																stroke="black"
																strokeLinecap="round"
															/>
															<path
																d="M14.667 2.75H2.16699C1.47664 2.75 0.916992 3.30964 0.916992 4C0.916992 4.69036 1.47664 5.25 2.16699 5.25H14.667C15.3573 5.25 15.917 4.69036 15.917 4C15.917 3.30964 15.3573 2.75 14.667 2.75Z"
																stroke="black"
															/>
														</svg>
													</button>
													<button
														onClick={() => {
															setEditData({
																resume_id: resume_id,
																job_id: localStorage.getItem("job_id") || "",
																question_id: elem.coding_ques_id,
																question_type: "coding",
																question: elem.question,
																sample_input: elem.sample_input,
																sample_output: elem.sample_output,
															});
															setEditStatus(true);
														}}
														className=""
													>
														<svg
															width="17"
															height="17"
															viewBox="0 0 17 17"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M15.7185 15.0356H1.28091C0.98487 15.0356 0.734375 15.2861 0.734375 15.5822C0.734375 15.8782 0.98487 16.1287 1.28091 16.1287H15.7185C16.0146 16.1287 16.2651 15.8782 16.2651 15.5822C16.2651 15.2861 16.0146 15.0356 15.7185 15.0356ZM0.757147 10.2535L0.734375 12.8267C0.734375 12.9634 0.77992 13.1228 0.893781 13.2139C1.00764 13.305 1.14428 13.3733 1.28091 13.3733L3.85418 13.3505C3.99081 13.3505 4.12744 13.2822 4.24131 13.1911L13.0769 4.35545C13.2819 4.1505 13.2819 3.78614 13.0769 3.58119L10.5265 1.0307C10.3215 0.825746 9.95715 0.825746 9.7522 1.0307L7.97596 2.80693L0.916553 9.86634C0.802692 9.9802 0.757147 10.1168 0.757147 10.2535ZM11.9156 3.96832L10.9136 4.9703L9.13735 3.19406L10.1393 2.19208L11.9156 3.96832ZM1.85022 10.4812L8.36309 3.96832L10.1393 5.74456L3.62645 12.2574H1.85022V10.4812Z"
																fill="black"
															/>
														</svg>
													</button>

													{/* <RegenerateQuestionModal
														questionId={index}
														getQuestions={getQuestions}
														questionType="coding"
													/>

													<UpdateCodingQuestionModal
														currentQuestionIndex={index}
														question={elem.question}
														sampleInput={elem.sample_input}
														sampleOutput={elem.sample_output}
														codingQuestionSet={data.coding_question}
														getQuestions={getQuestions}
													/>

													<DeleteQuestionModal
														getQuestions={getQuestions}
														currentQuestionIndex={index}
														codingQuestionSet={data.coding_question}
														section="coding"
													/> */}
												</div>
											</div>
										))}
									</div>
								</section>
							</>
						)}
					</div>
				)}
				<div className="flex justify-between mt-4 ">
					<div className="flex">
						<label className="text-lg font-semibold text-gray-700 mb-4">
							Assessment link Validity
						</label>

						<input
							type="number"
							value={validityDays}
							onChange={(e) => setvalidityDays(e.target.value)}
							placeholder="e.g., 80"
							className="w-[50%] p-2 border border-gray-300 rounded mb-4"
						/>
					</div>
					<div>
						<SendAssessmentLink
							validity_days={validityDays}
							candidateId={candidateId}
						></SendAssessmentLink>
					</div>
				</div>
			</div>
		</div>
	);
}
